import { Gamepad2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useGamesSummary } from './useGamesSummary'
import { useGamesDialog } from './useGamesDialog'

export function GamesButton({ me, className, label = 'Games' }: { me: string; className?: string; label?: string }) {
  const dialog = useGamesDialog()
  const s = useGamesSummary(me)
  const badge = s.waiting || s.open
  return (
    <Button type="button" size="sm" variant={s.waiting ? 'default' : 'outline'} className={cn('relative rounded-full', className)} onClick={dialog.openLobby} aria-label={s.waiting ? `${label}: your move is waiting` : s.open ? `${label}: ${s.open} open table${s.open === 1 ? '' : 's'}` : label}>
      <Gamepad2 className="size-4" />
      <span>{label}</span>
      {badge ? <span className={cn('num grid min-w-5 place-items-center rounded-full px-1 text-xs font-semibold tabular-nums', s.waiting ? 'bg-text-inverse text-brand' : 'bg-brand-accent text-text-inverse')}>{badge}</span> : null}
    </Button>
  )
}
